//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    noMargin: {
      type: Boolean,
      required: false
    },
    big: {
      type: Boolean,
      required: false
    },
    castom: {
      type: Boolean,
      required: false
    },
    wrapper: {
      type: Boolean,
      default: false
    },
    help: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    text: function() {
      this.makeConfig()
    }
  },
  data(){
    return {
      config: null
    }
  },
  mounted(){
    this.makeConfig()
  },
  methods: {
    makeConfig() {
      if (this.castom && this.wrapper) {
        if (this.text) {
          this.config = {
            content: this.text,
            followCursor: true,
            theme: 'dark terms',
            trigger: 'click',
            animation : 'fade'
          }
        } else {
          this.config = null
        }
        return
      }
      if (this.castom) {
        this.config = null
      } else {
        this.config = {
          content: this.text || 'Если не передается текст, выводится это сообщение',
          followCursor: true,
          // trigger: 'click',
          animation : 'fade'
        }
      }
    }
  }
}
